import moment from 'moment';
import {isEmpty, isNumber} from 'lodash';
import {errorFields} from './errorFields';

export const processFiles = (files) => {
  const formData = new FormData();
  files.forEach((element, index) => {
    const name = element.name;
    formData.append('file', element, name);
  });
  return formData;
};

export const validateUnique = (arr, field, value) => {
  const searchElement = arr.find((item) => item[field] === value);
  return typeof(searchElement) === 'undefined' ? true : false;
};

export const falsePrincipalPart = (arr = [], field) => {
  return arr.map((item) => ({
    ...item,
    [field]: 'N',
  }));
};

export const getTotalColumn = (arr = [], key) => {
  return arr.reduce((acc, value) => acc + (+value[key]), 0);
};

export const getTotalColumnPart = (arr = [], key, key2) => {
  return arr.reduce((acc, value) => acc + (+value[key] * +value[key2]), 0);
};

export const parseDatesFromWarranty = (warranty = {}) => {
  const {actualDate, dateTwc, lastDate,
    previousDate, repairDate, processDate,
    openRepairDate, endRepairDate, salesDate} = warranty;

  const parseActualDate = actualDate ? moment(actualDate) : null;
  const parseDateTwc = dateTwc ? moment(dateTwc) : null;
  const parseLastDate = lastDate ? moment(lastDate) : null;
  const parsePreviousDate = previousDate ? moment(previousDate) : null;
  const parseRepairDate = repairDate ? moment(repairDate) : null;
  const parseProcessDate = processDate ? moment(processDate) : null;
  const parseOpenRepairDate = openRepairDate ? moment(openRepairDate) : null;
  const parseEndRepairDate = endRepairDate ? moment(endRepairDate) : null;
  const parseSalesDate = salesDate ? moment(salesDate) : null;

  return {
    'actualDate': parseActualDate,
    'dateTwc': parseDateTwc,
    'lastDate': parseLastDate,
    'previousDate': parsePreviousDate,
    'repairDate': parseRepairDate,
    'processDate': parseProcessDate,
    'openRepairDate': parseOpenRepairDate,
    'endRepairDate': parseEndRepairDate,
    'salesDate': parseSalesDate,
  };
};

const validatePrincipalPart = ({principalPart = '', principalPartDescription = ''}) => {
  return principalPart === '' || principalPartDescription === '';
};

const validateFieldsForm = (warrantyFields, errorFields) => {
  let error = {
    'field': '',
    'error': false,
  };
  const errorArr = Object.keys(errorFields);
  errorArr.forEach((errorName) => {
    let field = warrantyFields[errorName];
    // convert the number to string to validate if is empty
    field = errorName === 'campaignId' && !field ? '' : field;
    const selectField = isNumber(field) && isNaN(field) === false ? `${field}` : field;
    if (isEmpty(selectField)) {
      error = {
        'field': errorFields[errorName],
        'error': true,
      };
    }
  });

  return error;
};


export const validateErrorsWarranty = (warranty) => {
  const {type, campaignFlag = false} = warranty;
  const fieldsForm = errorFields(type, campaignFlag);
  const validateForm = validateFieldsForm(warranty, fieldsForm);

  if (validateForm.error) {
    return {
      'error': true,
      'message': `El campo ${validateForm.field} es requerido`,
    };
  } else if (type !== 'VE' && validatePrincipalPart(warranty)) {
    return {
      'error': true,
      'message': 'Se requiere el ingreso de una parte principal (OFP)',
    };
  }
  
  return {
    'error': false,
    'message': null,
  };
};

export const parseTasksOptions = (tasks) => {
  return tasks.map((task) => {
    return {
      'text': task.taskId,
      'value': task.taskId,
    };
  });
};
